import React from "react";
import { FaReact, FaNodeJs, FaBitcoin } from "react-icons/fa";
import { SiExpress, SiJavascript } from "react-icons/si";
import { GrHeroku } from "react-icons/gr";
import { GiCoffeeCup } from "react-icons/gi";
import "./Credits.scss";

const Credits = () => (
  <div className="credits">
    <div className="credits__card">
      <h1 className="credits__title">Credits</h1>
      <div className="credits__author">
        <img
          src="/Kangaroo.png"
          alt="Profile avatar"
          className="credits__avatar"
        />
        <div className="credits__author-info">
          <div className="credits__author-name"><b>Drew</b></div>
          <div className="credits__author-role">Full Stack Developer</div>
        </div>
      </div>

      <div className="credits__section">
        <h2 className="credits__section-title">Tech Stack</h2>
        <div className="credits__tech-list">
          <span className="credits__tech-badge" title="React">
            <FaReact /> React (Frontend)
          </span>
          <span className="credits__tech-badge" title="Node.js">
            <FaNodeJs /> Node.js (Backend)
          </span>
          <span className="credits__tech-badge" title="Express">
            <SiExpress /> Express.js (API)
          </span>
          <span className="credits__tech-badge" title="JavaScript">
            <SiJavascript /> JavaScript (Everywhere)
          </span>
          <span className="credits__tech-badge" title="Heroku">
            <GrHeroku /> Deployed on Heroku
          </span>
        </div>
      </div>

      <div className="credits__section">
        <h2 className="credits__section-title">About This Project</h2>
        <p>
          <b>GuessNexus</b> is a collection of themed guessing games inspired by <span className="credits__inspiration">Wordle</span> and similar daily puzzle games.
        </p>
        <ul className="credits__list">
            <li>
                Designed for fun, challenge, and learning.
            </li>
            <li>
                All data and game logic is custom-built for a unique, replayable experience.
            </li>
            <li>
                Feedback or suggestions?
                <ul className="credits__sublist">
                <li>
                    Use the 'Submit Feedback' link in the page footer, or contact me at GuessNexusOfficial@gmail.com
                </li>
                </ul>
            </li>
        </ul>
      </div>

      <div className="credits__section">
        <h2 className="credits__section-title">Support This Project</h2>
        <p>
          Your support helps keep the games ad-free!
        </p>
        <p>
          If you enjoy playing GuessNexus and would like to support its continued development, consider supporting me below.
        </p>
        
        <div className="credits__support-options">
          <div className="credits__support-button">
            <a
              href="https://www.buymeacoffee.com/guessnexus"
              target="_blank"
              rel="noopener noreferrer"
              className="credits__coffee-link"
            >
              <GiCoffeeCup /> Gift me a coffee
            </a>
          </div>
          
          <div className="credits__support-divider">
            <span>or</span>
          </div>
          
          <div className="credits__support-button">
            <a
              href="https://commerce.coinbase.com/checkout/4338e753-02f3-4255-9fd8-8f32911a4023"
              target="_blank"
              rel="noopener noreferrer"
              className="credits__crypto-link"
            >
              <FaBitcoin /> Support with Crypto
            </a>
          </div>
        </div>
      </div>

      <div className="credits__footer">
        <span>© {new Date().getFullYear()}</span>
      </div>
    </div>
  </div>
);

export default Credits;